import styled from 'styled-components';

import Button from '@mlb/react-patterns/components/Button/button';
import { ButtonShapes, ButtonStyles } from '@mlb/react-patterns/components/Button/button.types';
import COLORS from '@mlb/react-patterns/style/universal.color.ts';
import { DFV_BG_COLOR } from '../DynamicFieldView.style';

const { mlbWhite, mlbBlack } = COLORS;

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    background-color: ${DFV_BG_COLOR};
    width: 100%;
    height: 100%;
    z-index: 2;
`;

export const ErrorHeading = styled.h2`
    font-family: var(--gameday-primary-font);
    color: ${mlbWhite};
    font-weight: 600;
`;

export const ErrorText = styled.span`
    font-family: var(--gameday-primary-font);
    color: ${mlbWhite};
    font-size: 18px;
    line-height: normal;
    text-align: center;
    padding: 0 32px;
    margin-bottom: 18px;
`;

export const StartButton = styled(Button).attrs({
    shape: ButtonShapes.SOLID,
    styleName: ButtonStyles.DEFAULT
})`
    border-radius: 28px;
    min-width: 200px;
    min-height: 48px;
    font-size: 16px;
    font-weight: 700;
    color: ${mlbBlack} !important;
`;
